import React, { Component } from 'react';
import openWithApp from '../../utils/openWithApp';

class Gnb extends Component {
  render() {
    const { profile, post, device } = this.props;
    const deviceOs = device.getIn(['os', 'name']);
    const marketUrl = 'https://itunes.apple.com/kr/app/kakaotog-kakaotalk/id362057947';
    const packageName = 'com.kakao.talk';

    return (
      <div id="kakaoHead" role="banner">
        <h1 className="tit_logo"><span className="ico_plus ico_logo">카카오톡 채널</span></h1>

        { (post || profile) && (
          <button type="button" className="btn_app">
            <a href={(post || profile).getScheme(deviceOs)} onClick={(e) => {
              e.preventDefault();
              openWithApp(deviceOs, 'kakaoplus', (post || profile).getSchemeHost(), packageName, marketUrl);
            }}
            >
              앱으로 보기<span className="ico_plus ico_app"></span>
            </a>
          </button>
        ) }

      </div>
    );
  }
};

export default Gnb;



// WEBPACK FOOTER //
// ./src/components/Gnb/index.js